import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/gray/addIconGray.svg";

const AddIconWhite = (props) => {
  return (
    <Wrapper onClick={props.onClick}>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default AddIconWhite;
